<template>
	<div class="mongolia">
		<i class="el-icon-loading"></i>
	</div>
</template>
<script>
export default {
	name: 'mongolia',
	data() {
		return {

		}
	}
}
</script>
<style scoped>
.mongolia {
	background: rgba(0,0,0,0.3);
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 3000;
}

i {
	position: absolute;
	top: 30%;
	left: 50%;
	font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/showMongolia.vue